import * as yup from 'yup';
import { IValidator } from '../IValidator';
import { DepositoModel } from './Model';

const depositoSchema = yup.object().shape<DepositoModel>({
  id: yup.number(),
  conteudoDoArquivo: yup.mixed(),
  conteudoDoArquivoPath: yup.string(),
  situacao: yup.number(),
  justificativaDaReprovacao: yup.string(),
  dataDoDeposito: yup.date(),
  identifier: yup.string()
});

const arquivoSchema = yup.object().shape({
  file: yup
    .mixed()
    .required('Arquivo obrigatório')
    .test(
      'fileFormat',
      'Apenas PDFs são aceitos',
      value => value && ['application/pdf'].includes(value.type)
    )
});

const justificativaSchema = yup.object().shape({
  justificativa: yup
    .string()
    .required('Por favor informe a justificativa')
});

export const DepositoModelValidator = new IValidator<DepositoModel>(
  depositoSchema
);

export const ArquivoValidator = new IValidator<{ file: File | null }>(
  arquivoSchema
);

export const JustificativaValidator = new IValidator<{ justificativa: string }>(
  justificativaSchema
);